import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./print.css";
import "./theme/modern.css";
import "./theme/planner.css";
// sets the modern look on <html> as the app starts, on every page (it used to come in with
// the one big bundle; the pages that import it now load later, see utils/lazyPage)
import "./theme/useKitTheme";
import * as serviceWorker from "./serviceWorker";
import { AppRouter } from "Router";
import { reloadOnNewVersion } from "./utils/reloadOnNewVersion";

ReactDOM.render(<AppRouter />, document.getElementById("root"));
reloadOnNewVersion();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
